import React from 'react';
import { AdminLayout } from '../components/AdminLayout';
import { Construction } from 'lucide-react';

export default function AdminStubPage({ title, section, description, eta }) {
  return (
    <AdminLayout title={section || title} breadcrumb={title}>
      <div style={{ maxWidth: 600 }}>
        <div style={{ background: '#fff', border: '1px solid rgba(221,212,197,0.7)', borderRadius: 16, padding: '40px', textAlign: 'center' }}>
          <div style={{ width: 56, height: 56, borderRadius: 14, background: 'rgba(8,29,48,.06)', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 16px' }}>
            <Construction size={24} color="var(--op-navy)" />
          </div>
          <h2 style={{ fontFamily: "'Inter Tight', sans-serif", fontSize: 18, fontWeight: 800, color: '#07121f', letterSpacing: '-.05em', margin: '0 0 8px' }}>
            {title}
          </h2>
          <p style={{ fontSize: 13, color: 'var(--op-muted)', margin: '0 0 20px', lineHeight: 1.6 }}>
            {description || `This section is in the product roadmap and will be available in a future update.`}
          </p>
          {eta && (
            <span style={{ fontSize: 11, fontWeight: 700, padding: '4px 12px', borderRadius: 20, background: 'rgba(0,140,134,.08)', color: '#008C86', textTransform: 'uppercase', letterSpacing: '.06em' }}>
              ETA: {eta}
            </span>
          )}
        </div>
      </div>
    </AdminLayout>
  );
}
